// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tableHeader___rpSWl{font-size:22px;padding:16px 0 0 16px;display:inline-block}.newReportBtn___AKfz9{margin:16px 6px 0 0}\n", "",{"version":3,"sources":["webpack://./src/routes/Reports/components/ReportsContainer/ReportsContainer.css"],"names":[],"mappings":"AAAA,qBACI,cAAA,CADJ,qBAAA,CAGI,oBAAA,CAGJ,sBANA,mBAAA","sourcesContent":[".tableHeader {\n    font-size: 22px;\n    padding: 16px 0 0 16px;\n    display: inline-block;\n}\n\n.newReportBtn {\n    margin: 16px 6px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableHeader": "tableHeader___rpSWl",
	"newReportBtn": "newReportBtn___AKfz9"
};
export default ___CSS_LOADER_EXPORT___;
